import { serializeFieldValue as e } from "./dateValue.js";
import { forwardRef as t } from "react";
import { jsxDEV as n } from "react/jsx-dev-runtime";
//#region lib/components/DatePicker/HiddenDateInput.tsx
var r = "/opt/render/project/src/shared-ui/lib/components/DatePicker/HiddenDateInput.tsx", i = t(function({ name: t, value: i, format: a, timeZone: o, required: s }, c) {
	return /* @__PURE__ */ n("input", {
		ref: c,
		type: "hidden",
		name: t,
		value: e(i, a, o),
		required: s,
		tabIndex: -1,
		"aria-hidden": !0
	}, void 0, !1, {
		fileName: r,
		lineNumber: 19,
		columnNumber: 9
	}, this);
});
//#endregion
export { i as HiddenDateInput };
